import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import * as yup from "yup";
import { Formik } from "formik";

import LoadingButton from "../components/LoadingButton";
import FormTextbox from "../components/FormTextbox";
import FormSelect from "../components/FormSelect";
import EditContainer from "../components/EditContainer";
import { useUser } from "../firebase";
import { filterFields, validRequiredString } from "../utils";
import { kvisYearOptions } from "../schema";

const validationSchema = yup.object().shape({
  firstName: validRequiredString("First Name"),
  lastName: validRequiredString("Last Name"),
  email: yup
    .string()
    .email("Email must be valid")
    .required("Email is required"),
  facebook: yup
    .string()
    .strict()
    .trim("Facebook must not have any leading or trailing spaces"),
  lineid: yup
    .string()
    .strict()
    .trim("Line ID must not have any leading or trailing spaces"),
  linkedin: yup
    .string()
    .strict()
    .trim("LinkedIn must not have any leading or trailing spaces"),
  website: yup
    .string()
    .strict()
    .trim("Website must not have any leading or trailing spaces"),
  kvisYear: yup.string().required("KVIS Graduation Year is required")
});

const fields = ["firstName", "lastName", "email", "facebook", "kvisYear", "linkedin", "website", "lineid"];

const EditGeneral = ({ location }) => {
  const { profile, updateProfile } = useUser();

  const values = filterFields(profile, fields);

  const handleUpdate = async (values, actions) => {
    await updateProfile(values);
    actions.setSubmitting(false);
  };

  return (
    <EditContainer title="General Info" noAdd>
      <div className="py-3">
        <Formik
          initialValues={values}
          validationSchema={validationSchema}
          onSubmit={handleUpdate}
          enableReinitialize
        >
          {formik => (
            <Form noValidate onSubmit={formik.handleSubmit}>
              <Row>
                <FormTextbox
                  as={Col}
                  formik={formik}
                  controlId="firstName"
                  label="First Name"
                  required
                />
                <FormTextbox
                  as={Col}
                  formik={formik}
                  controlId="lastName"
                  label="Last Name"
                  required
                />
              </Row>
              <FormSelect
                formik={formik}
                controlId="kvisYear"
                label="KVIS Graduation Year"
                options={kvisYearOptions}
                required
              />
              <FormTextbox
                formik={formik}
                controlId="email"
                label="Non-KVIS Email"
                required
              />
              <FormTextbox
                formik={formik}
                controlId="linkedin"
                label="LinkedIn"
              />
              <FormTextbox
                formik={formik}
                controlId="website"
                label="Personal Website"
              />
              <FormTextbox
                formik={formik}
                controlId="facebook"
                label="Facebook"
              />
              <FormTextbox
                formik={formik}
                controlId="lineid"
                label="Line ID"
              />
              <div className="d-flex justify-content-end align-items-center">
                {formik.dirty && (
                  <span className="text-muted mr-2">
                    <i>Unsaved Changes</i>
                  </span>
                )}
                <LoadingButton
                  isLoading={formik.isSubmitting}
                  variant="primary"
                  type="submit"
                >
                  Update
                </LoadingButton>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </EditContainer>
  );
};

export default EditGeneral;
